import { createSelector } from '@reduxjs/toolkit';
import { getEmployees } from './get-employees';
import { _sortByName } from '../utilities/_sortByName';

export const getEmployeesWithAccessForAdministrator = createSelector(getEmployees, function (employees) {
  return employees
    .filter(function (e) {
      return !e.deleted;
    })
    .filter(function (e) {
      return e.status !== 'TERMINATED';
    })
    .filter(function (e) {
      return e.accessLevel !== 'NONE';
    })
    .filter(function (e) {
      return e.email;
    })
    .map(function (e) {
      return {
        name: e.firstName + ' ' + e.lastName,
        firstName: e.firstName,
        lastName: e.lastName,
        uuid: e.uuid,
        email: e.email,
      };
    })
    .sort(_sortByName);
});
